import { createAction } from '@reduxjs/toolkit';
import { filtersZoomMasterType,filtersZoomSubAccountsType } from '@hooks/useZoom';
export const FETCHING_ZOOM_MASTER_LIST = 'FETCHING_ZOOM_MASTER_LIST'
export const FETCHING_ZOOM_SUB_ACCOUNTS_LIST = 'FETCHING_ZOOM_SUB_ACCOUNTS_LIST';
export const CREATE_ZOOM_MASTER = "CREATE_ZOOM_MASTER"
export const CREATE_ZOOM_SUB_ACCOUNT = "CREATE_ZOOM_SUB_ACCOUNT"
export const SYNC_SUB_ACCOUNT = "SYNC_SUB_ACCOUNT"
export const REMOVE_ZOOM_PRO_ACCOUNT = "REMOVE_ZOOM_PRO_ACCOUNT"
export const REMOVE_ZOOM_SUB_ACCOUNT = "REMOVE_ZOOM_SUB_ACCOUNT"
export const ASSIGN_FOR_USER = "ASSIGN_FOR_USER"


export type zoomCreationPayload = {
  server_app_account_id:string;
  server_app_client_id:string;
  server_app_client_secret:string;
  server_app_secert_token:string;
  server_app_verification_token:string;
  general_app_client_id:string;
  general_app_client_secret:string;
  general_app_secret_token:string;
  general_app_verification_token:string;
  webhook_token:string;
  webhook_verification_tokens:string
}
export type ZoomSubAccountCreationPayload = {
  zoomMasterId:number;
  email:string;
  firt_name:string;
  last_name:string;
}

export const fetchingZoomMasterList = createAction(FETCHING_ZOOM_MASTER_LIST,(filters: filtersZoomMasterType) => {
    return { payload: filters };
  }
);
export const fetchingZoomSubAccountsList = createAction(FETCHING_ZOOM_SUB_ACCOUNTS_LIST,(filters: filtersZoomSubAccountsType) => {
    return { payload: filters };
  }
);
export const createZoomMaster = createAction<zoomCreationPayload>(CREATE_ZOOM_MASTER);
export const createZoomSubAccount = createAction<ZoomSubAccountCreationPayload>(CREATE_ZOOM_SUB_ACCOUNT);
export const syncSubAccount = createAction(SYNC_SUB_ACCOUNT,(zoomMasterId: number) => {
    return { payload: zoomMasterId };
  }
);

export const removeZoomProAccount = createAction(REMOVE_ZOOM_PRO_ACCOUNT,(zoomMasterId: number) => {
    return { payload: zoomMasterId };
  }
);

export const removeZoomSubAccount = createAction(REMOVE_ZOOM_SUB_ACCOUNT,(zoomMasterId: number, zoomSubAccountEmail: string) => {
    return { payload: {zoomMasterId, zoomSubAccountEmail} };
  }
);

export const assignForUser = createAction(ASSIGN_FOR_USER,(zoomAccountId: number, authUserId: number | string, page: number, page_size: number, zoomMasterId: number) => {
    return { payload: {zoomAccountId, authUserId, page, page_size, zoomMasterId} };
  }
);

